export const PRODUCTS = `
query products(
    $tenant_id: Int!,
    $skip:  Int,
    $take:  Int,
    $orderBy:  ProductOrderInput,
    $filter:  FilterProductInput,
    $searchText: String
    $supplier_id: Int
  ){
  products(
    tenant_id:$tenant_id,
    skip: $skip,
    take: $take,
    orderBy: $orderBy,
    filter: $filter,
    searchText:$searchText
    supplier_id:$supplier_id
  ){
    __typename
    ...on Product{
      id
      name
      description
      cost
      weight
      height
      width
      length
      is_active
      stock
      supplier_id
      supplier{
        id
        fiscal_id_type
        fiscal_id
        product_address
        fantasy_name     
        crossdocking
        warehousing
      }
      product_category{
        category_id                     
      }          
      has_variants,    
      product_specification{
        id
        code
        stock
        is_active
        cost      
        product_picture{
          id
          url
        }
        option_1{
          id
          value
        }
        option_2{
          id
          value
        }
        option_3{
          id
          value
        }   
        internal_reference   
      } 
      warranty,
      is_private 
      logistic_mode
      product_status{
        id
        name,
        translation_key
        hex_color
      }
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const PRODUCT_COUNT = `
query productCount(
  $tenant_id: Int!, 
  $orderBy: ProductOrderInput, 
  $filter: FilterProductInput, 
  $searchText: String,
  $supplier_id: Int
){
productCount(
  tenant_id:$tenant_id, 
  orderBy:$orderBy, 
  filter:$filter, 
  searchText:$searchText,
  supplier_id:$supplier_id
){
  __typename
  ...on Count{
    count      
  }
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const PRODUCT = `
query product(
  $tenant_id: Int!, 
  $id: Int!
){
product(
  tenant_id:$tenant_id, 
  id:$id
){
  __typename
  ...on Product{
    id
      name
      description
      cost
      weight
      height
      width
      length
      is_active
      stock
      supplier_id
      supplier{
        id
        fiscal_id_type
        fiscal_id
        product_address 
        fantasy_name           
        crossdocking
        warehousing
      }
      product_category{
        category_id                     
      }   
    has_variants,    
    product_specification{
      id
      code
      stock
      is_active
      cost      
      product_picture{
        id
        url
      }
      option_1{
        id
        value
        product_variant_attribute{
          id
          name
        }
      }
      option_2{
        id
        value
        product_variant_attribute{
          id
          name
        }
      }
      option_3{
        id
        value
        product_variant_attribute{
          id
          name
        }
      }     
      internal_reference
    }
    is_private
    warranty
    logistic_mode
    product_status{
      id
      name,
      translation_key
      hex_color
    }
}
  ...on ResultError{
    status_code
    message
    message_translation_key
  }
}
}
`;

export const PRODUCT_BY_CODE = `
query productByCode(
  $tenant_id: Int!,
  $code: String!
){
  productByCode(
    tenant_id:$tenant_id,
    code:$code
  ){
    __typename
    ...on Product{
      id
      name
      product_specification{
        stock,
        cost
        code
      }
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const AVAILABLE_PRODUCT_ACTIONS = `
query availableProductActions(
	$tenant_id: Int!,
  $input: AvailableProductActionsInput!
){
  availableProductActions(
    tenant_id:$tenant_id,
    input:$input
  ){
    __typename
    ...on ProductAction{
      id
      name
      translation_key
      multiple
      level
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
      
    }
  }
}
`;

export const ESTIMATED_PRODUCT_ORDER_VALUES = `
query estimatedProductOrderValues(
  $tenant_id: Int!,
  $input: EstimatedProductOrderValuesInput!
){
  estimatedProductOrderValues(
    tenant_id: $tenant_id,
    input: $input
  ){
    __typename
    ...on OrderValues{
      total
      shipping_price
      product_cost
      commission
      supplier_commission
      fulfillment_commission
      cod_commission
      profit
      supplier_profit
      supplier_profits
    }
    ...on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
